import React from 'react';
import { Modal } from '@/components/design-system/atoms/modal';
import { PopUp } from '@/components/design-system/molecules/pop-up';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmLabel = 'Discard and Exit',
  cancelLabel = 'Keep Creating',
}) => {
  return (
    <Modal open={isOpen} onClose={onCancel}>
      <PopUp
        type="warning"
        title={title}
        description={message}
        primaryButtonProps={{
          title: confirmLabel,
          onClick: onConfirm,
          className:
            'flex h-[48px] items-center gap-1 py-[12px] font-sans text-[16px] font-medium leading-[20px] text-white bg-[#E5422F] hover:bg-gray-200 disabled:bg-E50 disabled:text-E75',
        }}
        secondaryButtonProps={{
          title: cancelLabel,
          onClick: onCancel,
          className:
            'flex h-[48px] items-center gap-1 py-[12px] font-sans text-[16px] font-medium leading-[20px] text-N900 bg-[#F3F4F5] hover:bg-gray-200 disabled:bg-E50 disabled:text-E75',
        }}
        className="!w-auto !p-0 !shadow-none"
        buttonOrder="primary-first"
      />
    </Modal>
  );
};

export default ConfirmationDialog;
